import { put } from 'redux-saga/effects';
import * as actions from '../actions/stepsActions';

export function* setStep(action) {
  const stepRoutes = {
    '/': 1,
    '/identifique-se': 1,
    '/cadastro': 1,
    '/revisao': 2,
    '/oferta-invalida': 0,
    '/assinante': 3,
    '/pagamento': 2,
    '/pagamento/sucesso': 3,
    '/pagamento/sucesso-pendente': 3,
    '/pagamento/erro': 4,
  };

  const stepObj = {
    step: stepRoutes[action.path], // get step number based on route
    path: action.path,
  };

  yield put(actions.receiveStep(stepObj));
}

export default setStep;
